module.exports = __webpack_public_path__ + "img/img-question-4-teacher-training-online.f710bb92.jpg";